<script>
    // import { createEventDispatcher } from 'svelte';
    export let order;
    // export let lang;
    // const dispatch = createEventDispatcher();
    // console.log(order);

    let timeD = new Date(order.timeOfOrder * 1000).toLocaleDateString();
    let timeT = new Date(order.timeOfOrder * 1000).toLocaleTimeString();
</script>

<div class="gap-2 p-4 bg-white border bg-opacity-20 grow">
    <h2>{(order.amountTotal / 100).toFixed(2)}</h2>
    <p>{order.orderId}</p>
    <p>✉️ {order.customerEmail}</p>
    <p>📅 {timeD} — 🕒 {timeT}</p>
</div>

<style>
</style>
